import axios from "axios";
import Vue from "vue";

const instance = axios.create({
  baseURL: process.env.VUE_APP_ROOT_API,
});

let requestCount = 0;

function showLoader() {
  if (requestCount === 0) {
    Vue.prototype.$loading(true);
  }
  requestCount++;
}

function hideLoader() {
  requestCount--;
  if (requestCount === 0) {
    Vue.prototype.$loading(false);
  }
}

// Interceptor para solicitudes
instance.interceptors.request.use(
  (config: any) => {
    showLoader();
    return config;
  },
  (error: any) => {
    hideLoader();
    return Promise.reject(error);
  }
);

// Interceptor para respuestas
instance.interceptors.response.use(
  (response: any) => {
    hideLoader();
    return response;
  },
  (error: any) => {
    hideLoader();
    return Promise.reject(error);
  }
);

export default instance;
